import React from "react";
import { useInView } from "./ProductDetail130";
import "./ProductDetail129.css";

/* ════════════════════════════════
   SYSTEM CAPABILITIES
════════════════════════════════ */
const CAPS = [
  { icon: "bi-camera-video-fill",   text: "24×7 AI Camera Monitoring",          color: "#0284c7" },
  { icon: "bi-lightning-fill",      text: "Real-Time Data Collection",           color: "#0369a1" },
  { icon: "bi-diagram-3-fill",      text: "Multi-Location Integration",          color: "#10aec6" },
  { icon: "bi-display-fill",        text: "Camera Status Monitoring",            color: "#10aec6" },
  { icon: "bi-cast",                text: "Live Streaming of Toll Operations",   color: "#0284c7" },
  { icon: "bi-robot",               text: "AI-Based Automated Reporting",        color: "#0369a1" },
  { icon: "bi-file-spreadsheet",    text: "Bulk Data Upload (Excel Support)",    color: "#10aec6" },
  { icon: "bi-camera-reels",        text: "Vehicle Image & Video Recording",     color: "#10aec6" },
  { icon: "bi-bar-chart-line-fill", text: "Toll Naka Performance Grading",       color: "#0284c7" },
  { icon: "bi-cloud-check-fill",    text: "Cloud-Based Multi-Plaza System",      color: "#0369a1" },
  { icon: "bi-person-badge-fill",   text: "Role-Based Secure Access",            color: "#10aec6" },
  { icon: "bi-shield-lock-fill",    text: "End-to-End Encrypted Transactions",   color: "#10aec6" },
];

 function ProductDetail131() {
  const [secRef, inView] = useInView(0.08);

  return (
    <section className="pd9-caps " ref={secRef}>
      <div className="pd9-caps__diagonal" />
      <div className="pd9-wrap pd9-caps__inner">

        {/* Left copy */}
        <div className={`pd9-caps__copy ${inView ? "pd9-caps__copy--in" : ""}`}>
          <span className="pd9-eyebrow pd9-eyebrow--dark">SYSTEM CAPABILITIES</span>
          <h2 className="pd9-h2 pd9-h2--dark">
            Built for 24×7<br /><span>Heavy-Duty Operations</span>
          </h2>
          <p className="pd9-body--dark">
            TPMS is engineered for the demands of high-volume Indian highway infrastructure —
            scalable from a 2-lane booth to a 50-lane expressway interchange without any architectural changes.
          </p>
          <p className="pd9-body--dark">
            Our AI models retrain continuously on new vehicle types, lighting conditions, and regional plates,
            ensuring performance improvements are fully automatic.
          </p>

          {/* Stat pills */}
          <div className="pd9-caps__pills">
            {[
              { val: "97%",  label: "Detection Accuracy" },
              { val: "21s",  label: "Clearance Time" },
              { val: "50+",  label: "Lanes Supported" },
              { val: "24/7", label: "Uptime" },
            ].map((p, i) => (
              <div key={i} className="pd9-caps__pill" style={{ animationDelay: `${i * 80}ms` }}>
                <strong>{p.val}</strong>
                <span>{p.label}</span>
              </div>
            ))}
          </div>

          <a href="/contact-us" className="pd9-btn pd9-btn--solid">
            Request Technical Brief <i className="bi bi-arrow-right" />
          </a>
        </div>

        {/* Right capability grid */}
        <div className="pd9-caps__grid">
          {CAPS.map((c, i) => (
            <div
              key={i}
              className={`pd9-cap-item ${inView ? "pd9-cap-item--in" : ""}`}
              style={{ animationDelay: `${i * 55}ms`, "--cc": c.color }}
            >
              <div className="pd9-cap-item__icon">
                <i className={`bi ${c.icon}`} />
              </div>
              <span>{c.text}</span>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
export default ProductDetail131;